import React, {Component} from 'react';
import AccountInvoiceContainer from '../../../containers/account_invoice_container';
import Loader from '../../universal/loader';
import {Button, Form, Grid, Header, Message, Segment} from "semantic-ui-react";
import * as hinchLogo from "../../../assets/hinchWhitebackgroundLogo.png";
import {APP_URL, BASE_URL} from "../../../constants/app_routes";
import DownloadingIntent from "../../universal/toast";
import {handleFileDownload} from "../../../utils/download_file";

class ViewInvoice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            invoiceStatus: undefined,
            message: undefined,
            invoiceId: undefined,
            isDownloading:false,
            positiveMessage:true
        }
    }

    componentWillMount() {
        this.setState({invoiceId: this.props.match.params.invoiceId});
        this.props.getInvoiceDetails(this.props.match.params.invoiceId)
    }

    handleChangeStatus = () => {
        const formData = new FormData();
        formData.append("invoice_id", this.state.invoiceId);
        formData.append("status", this.state.invoiceStatus);
        this.props.changeInvoiceStatus(formData,this.state.invoiceId,this.onSuccessCallBack);
    };

    onSuccessCallBack = (response) => {
        if (response.success) {
            this.setState({message: 'Successfully changed invoice Status'});
            setTimeout(() => {
                this.setState({message: undefined})
            }, 5000)
        }
    };

    handleDownload = async () => {
        this.setState({isDownloading:true,showDownload:true});
        const URL = BASE_URL+"/pdf/invoice/"+this.state.invoiceId;
        const fileName = this.props.invoiceDetail['filename'];
        await handleFileDownload(URL,fileName);
        this.setState({isDownloading:false});
    };

    handleRegenerate = async () => {
        this.props.regenerateInvoice(this.state.invoiceId,this.regenerationSuccess);
    };

    regenerationSuccess = async (response) => {
        if(response.invoice){
            this.setState({message:'Invoice Regenerated successfully'});
            setTimeout(() => {
                this.setState({message: undefined})
            }, 5000)
        }
        else {
            this.setState({message:'Invoice Regeneration failed. Retry again',positiveMessage:false});
        }
    };

    handleSendEmail = async () => {
        this.setState({sendingEmail:true});
        this.props.sendInvoiceMail(this.state.invoiceId,this.sendEmailSuccess);
    };

    sendEmailSuccess = async (response) => {
        if(response.success){
            this.setState({message:'Invoice Email sent successfully'});
            setTimeout(() => {
                this.setState({message: undefined})
            }, 5000)
        }
        else {
            this.setState({message:'Sending invoice E-mail failed. Retry again',positiveMessage:false});
        }
        this.setState({sendingEmail:false});
    };

    render() {
        const invoiceDetail = this.props.invoiceDetail;
        const mapStatus = {"processed": 0, "paid": 1,"cancelled":2};
        const invoiceStatus = [{key: 1, text: "Processed", value: 0}, {key: 2, text: "Paid", value: 1}];
        return (<div style={{width: '80%', margin: 'auto'}}>
            {this.props.isFetching && <Loader/>}
            {!this.props.isFetching && invoiceDetail && <div style={{width: '95%', margin: 'auto'}}>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Header size="large" content={"Invoice Number :" + invoiceDetail['invoice_number']}
                                    textAlign="left"/>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Header size="large" content={invoiceDetail['date']} textAlign="right"/>
                        </Grid.Column>
                    </Grid.Row>

                    {this.state.message && <Grid.Row>
                        <Grid.Column width={8}>

                        </Grid.Column>
                        <Grid.Column width={8}>
                            <div>
                                <Message positive={this.state.positiveMessage} negative={!this.state.positiveMessage} content={<span className="format-bold">{this.state.message}</span>}
                                         onDismiss={() => {
                                             this.setState({message: undefined})
                                         }}/>
                            </div>
                        </Grid.Column>
                    </Grid.Row>}

                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Segment style={{backgroundColor: '#249AC4', color: 'white', height: '100%'}}>
                                <div>
                                    <Grid stackable style={{marginTop: '0'}}>
                                        <Grid.Row style={{padding: '0 0 1% 0'}}>
                                            <Grid.Column width={5}>
                                                <img src={hinchLogo} alt="Hinch property logo"/>
                                            </Grid.Column>
                                            <Grid.Column width={11}>
                                                <div>
                                                    <div>
                                                        <p className="format-bold">Address</p>
                                                        <span>
                                                                Suite 3, First Floor Offices
                                                            </span>
                                                        <span>
                                                                East House,Chiltern Avenue,Amersham
                                                            </span>
                                                        <p>
                                                            Bucks, HP6 5AE
                                                        </p>
                                                    </div>
                                                </div>
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row style={{textAlign: 'center'}}>
                                            <div style={{width: '50%'}}>
                                                VAT Reg No: ASD453
                                            </div>
                                            <div style={{width: '50%'}}>
                                                Terms: On Receipt
                                            </div>
                                        </Grid.Row>
                                    </Grid>
                                </div>
                            </Segment>
                        </Grid.Column>
                        <Grid.Column width={8}>
                            <Segment style={{backgroundColor: '#F9FAFB', height: '100%'}}>
                                <div>
                                    <p className="format-bold"> Invoice To</p>
                                    <dl>
                                        <dt>Name</dt>
                                        <dd>: {invoiceDetail['company_name']}</dd>
                                        <dt>Address</dt>
                                        <dd>:  {invoiceDetail['company_address']}</dd>
                                        <dt>Email</dt>
                                        <dd>:  {invoiceDetail['company_email']}</dd>
                                    </dl>
                                </div>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <table width="100%" border="1" cellPadding="0" cellSpacing="0"
                                   style={{borderCollapse: 'collapse', borderColor: '#f5f5f5'}}>
                                <tbody>
                                <tr style={{backgroundColor: '#249AC4', color: 'white', height: '30px'}}>
                                    <th>Date</th>
                                    <th>Agent Ref.Id</th>
                                    <th>Agent Name</th>
                                    <th>Property Address</th>
                                    <th>Job Type</th>
                                    <th>Furnishing</th>
                                    <th>Size</th>
                                    <th>Amount</th>
                                </tr>
                                {invoiceDetail['invoice_estimates'].map((estimate, i) => {
                                    return ([
                                            <tr className="icon-button" key={estimate.id} onDoubleClick={()=>{window.open(APP_URL+"/account/invoice/estimate/view/"+estimate.id)}}>
                                                <td className="center-aligned">{estimate.inspection['inspection_time']['inspection_date']}</td>
                                                <td className="center-aligned">{estimate.inspection['reference_id']}</td>
                                                <td className="center-aligned">{estimate.inspection['agent_profile_name']}</td>
                                                <td width="20%"
                                                    style={{padding: '1%'}}>{estimate.inspection['property_address']}</td>
                                                <td className="formatcase">{estimate.inspection['inspection_type']}</td>
                                                <td className="format-capitalize center-aligned">{estimate.inspection['furnishing_type']}</td>
                                                <td className="center-aligned">{estimate.inspection['property_size']}</td>
                                                <td className="center-aligned">£ {estimate['total_amount_without_tax']}</td>
                                            </tr>,
                                            estimate['invoice_adjustments'] &&
                                            estimate['invoice_adjustments'].map((adjustment, i) => {
                                                return ([
                                                    <tr key={estimate.id + estimate.inspection.id +adjustment.id}>
                                                        <td colSpan={6} className="pad-all format-bold"> Adjustments </td>
                                                        <td className="center-aligned format-bold"
                                                            style={{borderRight: '0'}}>{adjustment.description}
                                                        </td>
                                                        <td className="center-aligned" style={{borderLeft: '0'}}>£ {adjustment.amount}</td>
                                                    </tr>
                                                ])
                                            })
                                        ]
                                    )
                                })
                                }
                                <tr>
                                    <td colSpan={6} className="right-aligned pad-all"> Subtotal</td>
                                    <td colSpan={2}
                                        className="center-aligned"> £ {invoiceDetail['total_amount_without_tax']}</td>
                                </tr>
                                <tr>
                                    <td colSpan={6} className="right-aligned pad-all"> VAT</td>
                                    <td colSpan={2} className="center-aligned"> £ {invoiceDetail['tax_amount']}</td>
                                </tr>
                                <tr>
                                    <td colSpan={6} className="right-aligned format-bold pad-all">Total Invoice Amount
                                    </td>
                                    <td colSpan={2}
                                        className="format-bold center-aligned format-bold">£ {invoiceDetail['total_amount_with_tax']}</td>
                                </tr>
                                </tbody>

                            </table>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>

                <Grid>
                    <Grid.Row>
                        <Grid.Column width={8}>
                            <Segment style={{backgroundColor: '#F9FAFB', height: '220px'}}>
                                <div>
                                    <p className="format-bold"> Bank Details</p>
                                    <dl style={{padding: '0 5%'}}>
                                        <dt>Bank Name</dt>
                                        <dd>: Barclays</dd>
                                        <dt>A/C. Name</dt>
                                        <dd>: Hinch PM</dd>
                                        <dt>Sort Code</dt>
                                        <dd>: 20-02-06</dd>
                                        <dt>A/C Number</dt>
                                        <dd>: 83943496</dd>
                                        <dt>Email</dt>
                                        <dd>: accounts@hinchpm.com</dd>
                                    </dl>
                                </div>
                            </Segment>
                        </Grid.Column>
                        {this.props.userRole === 'admin' && invoiceDetail.status !== "paid" ? <Grid.Column width={8}>
                            <div style={{height: '220px'}}>
                                <div>
                                <span className="format-bold half-wide">
                                    Invoice Status :
                                </span>
                                    <span className="half-wide">
                                    <Form.Dropdown selection
                                                   placeholder="Invoice Status"
                                                   fluid
                                                   options={invoiceStatus}
                                                   defaultValue={mapStatus[invoiceDetail.status]}
                                                   onChange={(e,option) => {
                                                       this.setState({invoiceStatus:option.value })
                                                   }}
                                    />
                                </span>
                                </div>
                                <div className="right-aligned pad-top pad-bottom">
                                    <Button content="Download" primary onClick={this.handleDownload}/>
                                    <Button content="Change Status" primary onClick={() => this.handleChangeStatus()}/>
                                </div>
                                <div className="right-aligned pad-top">
                                    <Button content="Regenerate Invoice" color="violet" onClick={this.handleRegenerate}/>
                                    <Button content="Send Invoice mail" disabled={this.state.sendingEmail} loading={this.state.sendingEmail} color={"teal"} onClick={this.handleSendEmail}/>
                                </div>
                            </div>
                        </Grid.Column> : <Grid.Column width={8}>
                            <Header textAlign="center" content={<div><span>Invoice has been</span><span style={{color:'green'}}> PAID</span></div>}/>
                            <div className="right-aligned pad-top">
                            <Button content="Download" primary onClick={this.handleDownload}/>
                            </div>
                        </Grid.Column>}
                    </Grid.Row>
                </Grid>
            </div>
            }
            {this.state.showDownload && <DownloadingIntent isDownloading={this.state.isDownloading}/>}
        </div>);
    }
}

export default AccountInvoiceContainer(ViewInvoice);


// WEBPACK FOOTER //
// ./src/views/accounts/invoice/view_invoice.js